import "styles/custom.css";
import * as React from "react";

import {
  getRegionNames,
  checkAccountType,
  resetServiceAccount,
} from "../components/Requests/Requests";

import {
  StandardScreen,
  StandardDropdown,
  StandardButton,
  StatusMessage,
  StandardSearchBox,
} from "../components/Layout";

import { PageLayout } from "../components/Layout/BaseComponents.jsx";

import {
  Dialog,
  DialogType,
  DialogFooter,
} from "office-ui-fabric-react/lib/Dialog";

import {
  PrimaryButton,
  DefaultButton,
} from "office-ui-fabric-react/lib/Button";

class ServiceAccounts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      regionNameChosen: "",
      regionNames: "",
      spHostUrl: "",

      error: "",
      warning: "",
      message: "",

      validAccountType: false,

      hideResetDialog: true,
    };
  }

  componentDidMount() {
    this.initializeSettings();
  }

  initializeSettings() {
    this.getRegionNames();
  }

  clearStatus = () =>
    this.setState({
      error: "",
      warning: "",
      message: "",
      validAccountType: false,
    });

  async getRegionNames() {
    this.setState({ loading: true });
    let response = await getRegionNames(this.props.accessToken);
    if (response.status === 200) {
      let data = await response.json();
      this.setState({
        loading: false,
        regionNames: data.map((item) => ({ key: item, text: item })),
      });
    } else {
      this.setState({
        loading: false,
        error: "Something went wrong",
        message: "",
      });
    }
  }

  async checkAccountType() {
    this.setState({ loading: true });
    this.clearStatus();
    const requestBody = {
      SPHostUrl: this.state.spHostUrl,
      RegionName: this.state.regionNameChosen,
    };
    try {
      let response = await checkAccountType(
        this.props.accessToken,
        requestBody,
      );
      let data = await response.json();
      if (response.status === 200) {
        if (data.eligible === true) {
          this.setState({ validAccountType: true });
        } else {
          this.setState({ warning: "Service account not eligible for reset." });
        }
      } else if (response.status === 404) {
        this.setState({ warning: data.message });
      } else {
        this.setState({ error: data.message });
      }
    } catch (e) {
      this.setState({ error: "Something went wrong" });
    } finally {
      this.setState({ loading: false });
    }
  }

  resetServiceAccount = async () => {
    this.setState({ loading: true, hideResetDialog: true });
    this.clearStatus();

    const requestBody = {
      SPHostUrl: this.state.spHostUrl,
      RegionName: this.state.regionNameChosen,
    };

    try {
      let response = await resetServiceAccount(
        this.props.accessToken,
        requestBody,
      );

      let data = await response.json();
      if (response.status === 200) {
        this.setState({ message: data.message });
      } else if (response.status === 400 || response.status === 404) {
        this.setState({ warning: data.message });
      } else {
        this.setState({ error: data.message });
      }
    } catch (e) {
      this.setState({ error: "Something went wrong" });
    } finally {
      this.setState({ loading: false });
    }
  }

  onSelectRegionName = (_, item) => {
    this.clearStatus();
    this.setState({ regionNameChosen: item.key });
  };

  onSPHostUrlChange = (newValue) => {
    this.clearStatus();
    this.setState({ spHostUrl: newValue });
  };

  render() {
    const {
      regionNames,
      spHostUrl,
      regionNameChosen,
      loading,
      error,
      warning,
      message,
      validAccountType,
      hideResetDialog,
    } = this.state;

    return (
      <PageLayout>
        <StandardScreen
          title="Reset a Service Account"
          description="Reset the Service Account for an installation."
          loading={loading}
        >
          <StandardDropdown
            label="Environment"
            selectedKey={regionNameChosen}
            onChange={this.onSelectRegionName}
            placeholder="Select Environment"
            options={regionNames}
            disabled={!regionNames || regionNames.length === 0}
          ></StandardDropdown>

          <StandardSearchBox
            label="SPHostUrl"
            placeholder="SPHostUrl"
            value={spHostUrl}
            disabled={!regionNameChosen}
            onChange={this.onSPHostUrlChange}
          ></StandardSearchBox>

          {!validAccountType && (
            <StandardButton
              text="Check Account"
              onClick={() => this.checkAccountType()}
              disabled={!spHostUrl || !regionNameChosen}
              size="wide"
            />
          )}

          {validAccountType && (
            <StandardButton
              text="Reset Account"
              onClick={() => this.setState({ hideResetDialog: false })}
              disabled={!spHostUrl || !regionNameChosen}
              destructive
              iconProps={{ iconName: "EraseTool" }}
            />
          )}

          <Dialog
            hidden={hideResetDialog}
            onDismiss={() => this.setState({ hideResetDialog: true })}
            dialogContentProps={{
              type: DialogType.normal,
              title: "Reset this service account?",
              subText:
                "This deletes the service account associated with this SPHostUrl. This can't be undone.",
            }}
            modalProps={{ isBlocking: true }}
          >
            <DialogFooter>
              <PrimaryButton
                onClick={this.resetServiceAccount}
                text="Reset account"
              />
              <DefaultButton
                onClick={() => this.setState({ hideResetDialog: true })}
                text="Cancel"
              />
            </DialogFooter>
          </Dialog>

          {message && <StatusMessage type="success">{message}</StatusMessage>}
          {warning && <StatusMessage type="warning">{warning}</StatusMessage>}
          {error && <StatusMessage type="error">{error}</StatusMessage>}
        </StandardScreen>
      </PageLayout>
    );
  }
}

export default ServiceAccounts;
